import EngineModule from '../EngineModule';

export default () => EngineModule.all.find(x => x.id === 'product-editor') || new EngineModule.UIEngineModule({
	type: 'ui',
	useFullWidth : false,
	id: 'product-editor',
	dependencies: [
		'oms-basket'
	],
	modulesBefore: [],
	modulesAfter: ['viewer-planner-furniture-editor'],
	usableCondition: null,
	displayCondition: {
		type : 'equal',
		component : 'K',
		property : '[*]TARGET.isProductEditorDisplayed',
		value : true
		// type: 'or',
		// LHS: {
		// 	type: 'equal',
		// 	component: 'K',
		// 	property: '[*]TARGET.hasThisModuleUsed("standing-customerMode")',
		// 	value: false
		// },
		// RHS: {
		// 	type: 'notequal',
		// 	component: 'K',
		// 	property: '[*]TARGET.parameters.mode',
		// 	value: 'client'
		// }
	},
	allowedCustomers: null,
	generateComponentConfiguration() {
		return {};
	}
});
